<template>
    <div class="footerText">
      <h3>PM-TW-1137-06-2018</h3>
      <small v-if="text === ''">2018 American Society of Clinical Oncology (ASCO) – June 1-5, 2018, Chicago, IL, USA  Abstract #4523</small>
      <small v-if="text !== ''" v-html="text"></small>
    </div>
</template>

<script>
export default {
  name: 'foot-text',
  props: ['text'],
  mounted: function () {
    // console.log(this.text)
  }
}
</script>

<style scoped>
.footerText h3 {margin-bottom:10px;}
</style>



// WEBPACK FOOTER //
// src/components/step5/footText.vue